import { type QueryFunctionContext, useQuery } from '@tanstack/react-query';
import type { AxiosResponse } from 'axios';

import { apiClient } from '@services/apiClient';

interface IResponse {
  data: {
    [key: string]: {
      data: Array<[number, number]>;
      type: number;
    };
  };
}

export const chartFftKey = (readingId?: number, isImpactVue?: boolean) => [
  'chartFft',
  readingId,
  isImpactVue,
];

export const chartFftFn = ({ queryKey }: QueryFunctionContext<(string | number)[]>) =>
  apiClient.get(`${APP_API_URL_V2}fsd/charts-fft${queryKey[2] ? '/impact-vue' : ''}`, {
    params: {
      readingId: queryKey[1],
    },
  });

const chartFftSelect = ({ data }: AxiosResponse<IResponse>) => {
  return data?.data;
};

export const useChartFftQuery = ({
  enabled,
  readingId,
  isImpactVue,
}: {
  enabled: boolean;
  readingId?: number;
  isImpactVue?: boolean;
}) => {
  return useQuery({
    // @ts-ignore TODO: update react-query to v5
    queryKey: chartFftKey(readingId, isImpactVue),
    queryFn: chartFftFn,
    enabled,
    cacheTime: 10 * 60 * 1000,
    select: chartFftSelect,
  });
};
